type LocationOriginEncoding = 'base64' | 'none';

export const LOCATION_ORIGIN_QUERY_PARAM = 'lo';

export const getEncodedLocationOrigin = (encoding: LocationOriginEncoding = 'none') => {
  if (encoding === 'base64') {
    return btoa(location.origin);
  }
  return location.origin;
};

export const getEncodedLocationOriginQueryParam = (
  encoding: LocationOriginEncoding = 'none',
  prefix = '&',
) => `${prefix}${LOCATION_ORIGIN_QUERY_PARAM}=${getEncodedLocationOrigin(encoding)}`;
